<template>
  <v-card>

    <v-card-title>

      <v-text-field v-model="search" append-icon="search" label="Cauta produs dupa nume sau cod" placeholder="Cautare..."
        single-line>
      </v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="$store.state.products.products" :search="search" class="elevation-1">
      <template v-slot:[`item.action`]="{ item }">
        <router-link :to="{ name: 'Stocuri', params: { productId: item.id } }">
          <v-icon class="mr-2">all_inbox</v-icon>
        </router-link>
        <router-link :to="{ name: 'Editare produs', params: { id: item.id } }">
          <v-icon class="mr-2">edit</v-icon>
        </router-link>
        <v-icon @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
      <router-link to="/products/create">
        <v-btn color="red" fab small dark fixed bottom justify-center>
          <v-icon>add</v-icon>
        </v-btn>
      </router-link>
    </v-layout>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'ListProducts',
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Denumire produs',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Cantitate totala',
          align: 'center',
          value: 'totalQuantity',
          sortable: true,
        },
        {
          text: 'Cod',
          align: 'center',
          value: 'code',
          sortable: true,
        },
        {
          text: 'Pret achizitie',
          align: 'center',
          value: 'buyPrice',
          sortable: true,
        },
        {
          text: 'Pret vanzare',
          align: 'center',
          value: 'sellPrice',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],

      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.getProducts();
  },
  methods: {
    ...mapActions('products', ['getProducts', 'delete']),
    async deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        await this.delete(item.id);
      }
    },
  },
};
</script>
